import { FunctionComponent, useEffect, useState } from "react";
import { getPreference } from "../../functions/getPreference";

type Servierhinweise_Props = {
  bewohnerid: Number;
  zeit: string;
};

export const Servierhinweise: FunctionComponent<Servierhinweise_Props> = ({ bewohnerid, zeit }) => {
  const [bewohner, setBewohner]: any = useState({});
  const [hints, setHints]: any = useState([]);
  const [hintsDisplay, setHintsDisplay]: any = useState(null);

  const checkHints = (zeit: any) => {
    let hintFields = [
      ["Mundgerecht", "Früh", "mundgerecht"],
      ["Mundgerecht", "Mittag", "mundgerecht_mittag"],
      ["Mundgerecht", "Abend", "mundgerecht_abend"],
      ["Weiche Kost", "Mittag", "weiche_kost_mittag"],
      ["Ohne Rinde", "Früh", "rinde"],
      ["Ohne Rinde", "Abend", "rinde_abend"],
      ["Geschmiert", "Früh", "geschmiert"],
      ["Geschmiert", "Abend", "geschmiert_abend"],
      ["Passiert", "Früh", "passiert_frueh"],
      ["Passiert", "Mittag", "passiert"],
      ["Passiert", "Abend", "passiert_abend"],
      ["Hochkalorisch", "Früh", "hochkalorisch_frueh"],
      ["Hochkalorisch", "Mittag", "hochkalorisch"],
      ["Hochkalorisch", "Abend", "hochkalorisch_abend"],
      ["Geviertelt", "Früh", "geviertelt_frueh"],
      ["Geviertelt", "Abend", "geviertelt_abend"]
    ];
    setHints(hintFields.filter((entry) => entry[1] === zeit && bewohner["bewohner_" + entry[2]] === "1").map((entry) => entry[0]));
  };

  useEffect(() => {
    setHintsDisplay( hints.join(", ") ) ;
    getPreference("senioren.bewohner", (value: any) => setBewohner(JSON.parse(value).filter((entry: any) => entry.betriebe_bewohner_id === bewohnerid)[0]));
  }, [bewohnerid, zeit]);

  useEffect(() => {
    checkHints(zeit);
  }, [bewohner]);

  useEffect(() => {
    if( ! hints ) return ;
    setHintsDisplay( hints.join(", ") ) ;
  }, [hints]);

  return <span>{ hintsDisplay }</span>;
};
